let toggleTarget = (e) => {
  const $trigger = e.currentTarget;
  const $target = document.querySelectorAll($trigger.getAttribute('data-show-target'));

  if(e.type === 'click') {
    $target.forEach(el => {
      if(el.style.display === '') {
        el.style.display = 'none';
      } else {
        el.style.removeProperty('display');
      }
    });

    return;
  }

  if($trigger.getAttribute('type') === 'checkbox') {
    $target.forEach(el => {
      if(
        ($trigger.checked === true && !$trigger.hasAttribute('data-show-target-inverse'))
        || ($trigger.checked !== true && $trigger.hasAttribute('data-show-target-inverse'))
      ) {
        el.style.removeProperty('display');
      } else {
        el.style.display = 'none';
      }
    });

    return;
  }

  if($trigger.getAttribute('type') === 'radio') {
    document.querySelectorAll('input[type="radio"][name="' + $trigger.name + '"][data-show-target]').forEach(el => {
      document.querySelectorAll(el.getAttribute('data-show-target')).forEach(el => {
        el.style.display = 'none';
      });
    });

    $target.forEach(el => {
      el.style.removeProperty('display');
    });

    return;
  }
};

window.addEventListener('vueloaded', () => {

  document.querySelectorAll('[data-show-target]').forEach(el => {

    if(el.tagName.toLowerCase() !== 'input') {
      el.addEventListener('click', toggleTarget);

      return;
    }

    if('checkbox' === el.getAttribute('type')) {
      el.addEventListener('change', toggleTarget);

      if(el.checked) {
        let event;

        if(typeof(Event) === 'function') {
            event = new Event('change', {bubbles: true, cancelable: false});
        } else {
            event = document.createEvent('Event');
            event.initEvent('change', true, false);
        }

        el.dispatchEvent(event);
      }

      return;
    }

    if('radio' === el.getAttribute('type')) {
      document.querySelectorAll('input[type="radio"][name="'+el.name+'"]').forEach(el => {
        el.addEventListener('change', toggleTarget);

        if(el.checked) {
          let event;

          if(typeof(Event) === 'function') {
              event = new Event('change', {bubbles: true, cancelable: false});
          } else {
              event = document.createEvent('Event');
              event.initEvent('change', true, false);
          }

          el.dispatchEvent(event);
        }
      });

      return;
    }

  });

});
